import type { ReactNode } from 'react';
import { useAuth } from '../../auth/useAuth';
import { BottomNav } from './BottomNav';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { visibleNavItems } from './navItems';

// One application shell that adapts by breakpoint (Tailwind `tablet:`/
// `desktop:` variants defined in tailwind.config.js) rather than shipping
// separate mobile/desktop builds — v6 architecture doc §5.
export function AppShell({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const items = visibleNavItems(user?.role);

  return (
    <div className="flex min-h-screen bg-ink bg-radial-gold text-slate-200">
      <Sidebar items={items} />
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar />
        <main className="mx-auto w-full max-w-[1400px] flex-1 overflow-y-auto p-4 pb-24 tablet:p-6 tablet:pb-6">{children}</main>
      </div>
      <BottomNav items={items} />
    </div>
  );
}
